import '../__generated__/styles/accordion.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { V2ChevronUpIcon, ChevronUpIcon, V2ChevronDownIcon, ChevronDownIcon } from '@swift-paypal/pp-react-icons';
import { useTheme } from '@swift-paypal/pp-react-theme';

var styles = {"ppvx_accordion":"ppvx_accordion___2-7-7","ppvx_accordion__row":"ppvx_accordion__row___2-7-7","ppvx_accordion__body":"ppvx_accordion__body___2-7-7","ppvx_accordion__header":"ppvx_accordion__header___2-7-7","ppvx_accordion__svg-icon":"ppvx_accordion__svg-icon___2-7-7","ppvx_accordion__header--with-svg-icon":"ppvx_accordion__header--with-svg-icon___2-7-7","ppvx--v2":"ppvx--v2___2-7-7","ppvx--v1":"ppvx--v1___2-7-7"};

var Accordion = function (_ref) {
  var name = _ref.name,
      className = _ref.className,
      theme = _ref.theme,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["name", "className", "theme", "children"]);

  var accordionRows = React.Children.map(children, function (child, idx) {
    return React.cloneElement(child, {
      accordionName: name || 'Accordion',
      rowNumber: idx + 1,
      theme: theme
    });
  });
  var accordionClasses = clsx(styles.ppvx_accordion, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: accordionClasses
  }, rest), accordionRows);
};

var AccordionRow = function (_ref) {
  var accordionName = _ref.accordionName,
      heading = _ref.heading,
      rowNumber = _ref.rowNumber,
      className = _ref.className,
      headerClassName = _ref.headerClassName,
      contentClassName = _ref.contentClassName,
      iconClassName = _ref.iconClassName,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      onClick = _ref.onClick,
      theme = _ref.theme,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["accordionName", "heading", "rowNumber", "className", "headerClassName", "contentClassName", "iconClassName", "isOpen", "onClick", "theme", "children"]);

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShowState = _useState2[1];

  var handleClick = function (event) {
    if (onClick) {
      onClick(event, parseInt(rowNumber, 10), !show);
    }

    setShowState(!show);
  };

  useEffect(function () {
    setShowState(isOpen);
  }, [isOpen]);

  var _theme = useTheme('Accordion Row', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var rowClass = clsx(styles.ppvx_accordion__row, _defineProperty({}, styles['ppvx--v2'], isThemeV2), className);
  var headerClass = clsx(styles.ppvx_accordion__header, styles['ppvx_accordion__header--with-svg-icon'], headerClassName);
  var iconClass = clsx(styles['ppvx_accordion__svg-icon'], iconClassName);
  var bodyClass = clsx(styles.ppvx_accordion__body, contentClassName);
  var rowId = "".concat(accordionName, "-row").concat(rowNumber);
  var contentId = "".concat(accordionName, "-content").concat(rowNumber);
  /* istanbul ignore next */

  var ExpandedIcon = isThemeV2 ? V2ChevronUpIcon : ChevronUpIcon;
  var CollapsedIcon = isThemeV2 ? V2ChevronDownIcon : ChevronDownIcon;
  return /*#__PURE__*/React.createElement("div", {
    className: rowClass
  }, /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    id: rowId,
    className: headerClass,
    "data-row": rowNumber,
    "aria-expanded": show,
    "aria-controls": contentId,
    onClick: function (e) {
      return handleClick(e);
    }
  }, rest), heading, show ? /*#__PURE__*/React.createElement(ExpandedIcon, {
    size: "sm",
    className: iconClass
  }) : /*#__PURE__*/React.createElement(CollapsedIcon, {
    size: "sm",
    className: iconClass
  })), /*#__PURE__*/React.createElement("div", {
    id: contentId,
    className: bodyClass,
    "aria-labelledby": rowId,
    role: "region"
  }, children));
};

export { Accordion, AccordionRow };
